import React from 'react'
import { generateMargin } from '../Spacing/Margin'
import { generatePadding } from '../Spacing/Padding'

const HeadingTwo = ({ text, color, margin, padding, className, headingCSSStyles }) => {
  return (
    <React.Fragment>
        <h2 style={{color:color,...generatePadding(padding?.direction,padding?.number), ...generateMargin(margin?.direction,margin?.number), ...headingCSSStyles}} className={`text-[40px] font-bold font-DMSans ${className}`}>{text}</h2>
    </React.Fragment>
  )
}

export default HeadingTwo